import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/quickBetCardRacing.css';
import SingleButton from "../modules/racing/components/singleButton";
import {getText} from '../../../helpers/localization';
import {TO_WIN, TO_WIN_EW} from '../modules/racing/constants/identifiers';
import {ASSETS_URL} from '../../../constants/endpoints';
import {calculateTimeDifference, formatTimeInSecondsToS} from '../../../helpers/helperFunctions';
// helpers
import {getOddsFromOddsType} from '../../../helpers/oddsHelpers';
import {hasEventTypeRacerNumberUI} from '../modules/racing/helpers/racersHelper';
import {MOTOR_RACING, NMB, PRE, SPEEDWAY} from '../../../constants/identifiers';

//actions
import {addOpenBet, removeOpenBet} from '../actions/openBetsActions';
import {getGameFromChannel} from "../helpers/gameHelpers";

import {sortRacers} from '../modules/racing/helpers/sortingHelper';
import device from 'current-device';
import eventLiveCounter from "./eventLiveCounter";

const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        games: state.vpp.games,
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedGameIndex: state.vpp.selectedGameIndex,
        openBetsList: state.vpp.openBetsList,
        selectedRaceCardSortField: state.vpp.selectedRaceCardSortField,
        selectedOddsType: state.vpp.selectedOddsType,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        serverTimeOffset: state.vpp.serverTimeOffset,
        systemLanguage: state.vpp.systemLanguage
    };
};

class QuickBetCardRacing extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();
        this.isEventLive = false;
        this.racerClickArray = [];
        this.state = {
            games: storeData.vpp.games,
            events: storeData.vpp.events,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            openBetsList: storeData.vpp.openBetsList,
            selectedRaceCardSortField: storeData.vpp.selectedRaceCardSortField,
            selectedOddsType: storeData.vpp.selectedOddsType,
            systemLanguage: storeData.vpp.systemLanguage,
            timeLeft: this._getTimeLeft(),
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            serverTimeOffset: storeData.vpp.serverTimeOffset,
        };
    }

    _getTimeLeft() {
        let nextEventTime = this._getNextEventTime();
        if (nextEventTime !== undefined) {
            let timeLeft = calculateTimeDifference(new Date(Date.now() - this.state.serverTimeOffset), nextEventTime) / 1000;
            if (Math.floor(timeLeft) === 0) {
                setTimeout(() => this.isEventLive = true, 200);
                setTimeout(() => this.isEventLive = false, 2000);
            }
            return timeLeft;
        }
        return undefined;
    }

    _updateTimeLeft() {
        this.setState({
            ...this.state,
            timeLeft: this._getTimeLeft()
        });
    }

    componentDidMount() {
        this.interval = setInterval(this._updateTimeLeft.bind(this), 1000);
    }

    _getNextEventTime() {
        let eventTime;
        let event;
        if (this.state && this.state.nextEventsTimeStamp) {
            event = this.state.nextEventsTimeStamp.find((event) => event.channel === this.state.games[this.state.selectedGameIndex].channel && Number(event.eventTime) >= (new Date().getTime() - this.state.serverTimeOffset));
            if (event) {
                eventTime = Number(event.eventTime);
            }
        }
        return eventTime;
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                games: storeData.vpp.games,
                events: storeData.vpp.events,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                openBetsList: storeData.vpp.openBetsList,
                selectedRaceCardSortField: storeData.vpp.selectedRaceCardSortField,
                selectedOddsType: storeData.vpp.selectedOddsType,
                systemLanguage: storeData.vpp.systemLanguage,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                serverTimeOffset: storeData.vpp.serverTimeOffset,
            });
        }
    }

    _getListOfSingleBetsCardsUI(isEnabled) {
        let listOfSingleBetsCardsUI = [];
        if (this.state.events.length > 0 && this.state.events[this.state.selectedEventIndex].racers !== undefined) {
            let listOfSingleBetsCards = this.state.events[this.state.selectedEventIndex].racers.sort(sortRacers.bind(this.state));
            let carRacingContainerStyle = '';
            let eventType = this.state.events[this.state.selectedEventIndex].eventType;
            if (eventType === SPEEDWAY || eventType === MOTOR_RACING) {
                carRacingContainerStyle = style.buttonContainerMotorRacing;
            }

            listOfSingleBetsCardsUI = listOfSingleBetsCards.map((racer, index) => {

                let marketId = TO_WIN.code + '-' + racer.num;
                let isLast = index === listOfSingleBetsCards.length - 1;
                this.racerClickArray.push({num: racer.num, value: false});
                let button = this.getRacerButtonUI(racer, marketId, racer.num, index, isLast, isEnabled);

                return (
                    <div key={index} className={`${style.buttonContainer} ${carRacingContainerStyle}`}>{button}</div>);
            });

        }
        return listOfSingleBetsCardsUI;
    }

    _checkIfButtonsEnabled() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];
        let selectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex];
        if (selectedEvent) {
            for (let i = 0; i < storeData.vpp.noMoreBetsEventList.length; i++) {
                if (storeData.vpp.noMoreBetsEventList[i].eventId === selectedEvent.eventId && storeData.vpp.noMoreBetsEventList[i].gameChannel === selectedGame.channel) {
                    if (selectedGame.controllerState === NMB || selectedGame.controllerState === PRE) {
                        return false;
                    }
                    break;
                }
            }
        }
        return true;
    }

    render() {

        let timeCounter;
        let betTitle;
        let betButtonsListUI = [];
        let lastPositionContainerHeight = '';

        if (device.mobile() && !device.tablet()) {
            if (window.screen.orientation && window.orientation !== undefined) {
                if (window.orientation === -90 || window.orientation === 90) {
                    timeCounter = (
                        <div>{this.state.timeLeft !== undefined && !this.isEventLive ? eventLiveCounter(formatTimeInSecondsToS(this.state.timeLeft)) : ''}</div>);
                }
            } else if (window.orientation !== undefined) {
                if (window.orientation === -90 || window.orientation === 90) {
                    timeCounter = (
                        <div>{this.state.timeLeft !== undefined && !this.isEventLive ? eventLiveCounter(formatTimeInSecondsToS(this.state.timeLeft)) : ''}</div>);
                }
            }
        }
        if (timeCounter === undefined) {
            let isEnabled = this._checkIfButtonsEnabled();
            let betButtons = this._getListOfSingleBetsCardsUI(isEnabled);
            betTitle = isEnabled ? (
                    <div className={style.betTitle}>{getText('SELECT_YOUR_BET_BELOW', this.props.store)}</div>)
                : (<div className={style.betTitle}>{getText('NO_MORE_BETS', this.props.store)}</div>);
            switch (betButtons.length) {
                case 12:
                case 8:
                    for (let i = 0; i < betButtons.length / 4; i++) {
                        let auxUI = (<div key={i} className={style.buttonsRow}>
                            <div className={style.buttonCol}>{betButtons[i * 4]}</div>
                            <div className={style.buttonCol}>{betButtons[i * 4 + 1]}</div>
                            <div className={style.buttonCol}>{betButtons[i * 4 + 2]}</div>
                            <div className={style.buttonCol}>{betButtons[i * 4 + 3]}</div>
                        </div>);
                        betButtonsListUI.push(auxUI);
                    }
                    break;
                case 6:
                    for (let i = 0; i < 2; i++) {
                        let auxUI = (<div key={i} className={style.buttonsRow}>
                            <div className={style.buttonCol}>{betButtons[i * 3]}</div>
                            <div className={style.buttonCol}>{betButtons[i * 3 + 1]}</div>
                            <div className={style.buttonCol}>{betButtons[i * 3 + 2]}</div>
                        </div>);
                        betButtonsListUI.push(auxUI);
                    }
                    break;
                case 10:
                    let auxUI = (<div key={0} className={style.buttonsRow}>
                        <div className={style.buttonCol}>{betButtons[0]}</div>
                        <div className={style.buttonCol}>{betButtons[1]}</div>
                        <div className={style.buttonCol}>{betButtons[2]}</div>
                    </div>);
                    betButtonsListUI.push(auxUI);
                    auxUI = (<div key={1} className={style.buttonsRow}>
                        <div className={style.buttonCol}>{betButtons[3]}</div>
                        <div className={style.buttonCol}>{betButtons[4]}</div>
                        <div className={style.buttonCol}>{betButtons[5]}</div>
                        <div className={style.buttonCol}>{betButtons[6]}</div>
                    </div>);
                    betButtonsListUI.push(auxUI);
                    auxUI = (<div key={2} className={style.buttonsRow}>
                        <div className={style.buttonCol}>{betButtons[7]}</div>
                        <div className={style.buttonCol}>{betButtons[8]}</div>
                        <div className={style.buttonCol}>{betButtons[9]}</div>
                    </div>);
                    betButtonsListUI.push(auxUI);
                    break;
            }
            let numberOfRacers = betButtons.length;
            if (numberOfRacers === 8 || numberOfRacers === 6) {
                lastPositionContainerHeight = style.lastPositionContainerHeight;
            }
        }

        let lastPositionsUI = this._getLastPositionsUI();

        return (
            <div className={style.mainContainer}>
                {betTitle}
                {betButtonsListUI}
                {timeCounter}
                <div
                    className={`${style.lastPositionsContainer} ${lastPositionContainerHeight}`}>{lastPositionsUI}</div>
            </div>
        );
    }

    getRacerButtonUI(racer, marketId, marketNum, index, isLast, isEnabled) {
        let bet = this._isChecked(racer);
        let isChecked = bet !== undefined;
        let onClick = (racer) => {
            if (!isEnabled) {
                return;
            }
            !isChecked
                ? this._placeBet(racer, marketId, marketNum)
                : this._removeBet(bet);
        }
        let isCheckedStyle = isChecked
            ? style.checked
            : style.buttonWrapper;

        let eventType = this.state.events[this.state.selectedEventIndex].eventType;
        let odd = getOddsFromOddsType(racer.oddsFirst, this.state.selectedOddsType);

        let store = this.props.store;
        let storeData = store.getState();
        let oddsButtonContainerWidth = hasEventTypeRacerNumberUI(eventType) ? '' : style.oddsButtonContainerWidth;
        let disabledStyle = isEnabled
            ? ''
            : style.disabled;
        let racerIcon = hasEventTypeRacerNumberUI(eventType)
            ? style.racerIcon
            : this.state.games[this.state.selectedGameIndex].assetsPath === 'motorRacing' ? style.speedwayParkIconAttract : style.motorRacerIconAttract;
        return (
            <div id={'racer_' + racer.num} className={style.attractSingleContainer}>
                <div id={'racer_silk_' + racer.num} className={`${racerIcon}`}>
                    <img
                        src={`${ASSETS_URL}${getGameFromChannel(this.state.events[this.state.selectedEventIndex].channel, storeData.vpp.games).assetsPath}/silks/silk${Number(racer.silk) + 1}.png`}
                        className={style.racerIconImage}
                        alt={`icon${racer.silk}`} onClick={() => onClick(racer)}/>
                </div>
                <div id={'racer_nameButtonContainer_' + racer.num} className={style.buttonsContainer}>
                    <div id={'racer_name_' + racer.num} className={style.racerName} onClick={() => onClick(racer)}>
                        {racer.name}
                    </div>
                    <div id={'racer_numberButtonContainer_' + racer.num} className={`${style.numberButtonContainer}`}>
                        <div id={'slider_numberContainer_' + racer.num} className={style.numberContainer}
                             onClick={() => onClick(racer)}>
                            {
                                hasEventTypeRacerNumberUI(eventType)
                                    ? (<div id={'slider_racer_number_' + racer.num}
                                            className={style.silkNumber}>{racer.num}</div>)
                                    : ''
                            }
                        </div>
                        <div id={'racer_buttonContainer_' + racer.num}
                             className={`${style.oddsButtonContainer} ${oddsButtonContainerWidth} ${disabledStyle}`}>
                            <SingleButton
                                isQuickBet={true}
                                isClicked={this.racerClickArray.find(obj => obj.num === racer.num).value}
                                htmlId={'racer_button_' + racer.num}
                                style={`${isCheckedStyle}`}
                                sbLabel={odd}
                                sbSub={''}
                                isChecked={isChecked}
                                isEnabled={isEnabled}
                                circleSize={'medium'}
                                racer={racer}
                                marketId={TO_WIN.code + '-' + racer.num}
                                marketNum={racer.num}
                                store={this.props.store}
                                buttonStyle={style.buttonCustomStyle}
                                betType={TO_WIN}
                                odd={odd}
                            />
                        </div>
                    </div>
                </div>

            </div>
        );
    }

    _placeBet(racer, marketId, marketNum) {
        let bet = {
            game: this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex],
            event: this.props.store.getState().vpp.events[this.props.store.getState().vpp.selectedEventIndex],
            betType: TO_WIN,
            market: {
                id: marketId,
                num: marketNum,

            },
            racers: [racer]
        };

        this.props.store.dispatch(addOpenBet(bet, this.state.openBetsList));
        this._updateClickStatus(racer.num, true);
        setTimeout(() => this._updateClickStatus(racer.num, false), 1000);
    }

    _updateClickStatus(racerNum, clickStatus) {
        this.racerClickArray = this.racerClickArray.map(obj => {
            if (obj.num === racerNum) {
                return {...obj, value: clickStatus};
            }
            return obj;
        })
    }

    _removeBet(bet) {
        this.props.store.dispatch(removeOpenBet(bet));
    }

    _isChecked(racer) {
        let openBetsList = this.state.openBetsList;
        if (openBetsList.length > 0) {
            let currentSelectedGame = this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex];
            let currentSelectedEvent = this.props.store.getState().vpp.events[this.props.store.getState().vpp.selectedEventIndex];
            for (let i = 0; i < openBetsList.length; i++) {
                if (openBetsList[i].bets[0].game.channel === currentSelectedGame.channel && openBetsList[i].bets[0].event.eventId === currentSelectedEvent.eventId) {
                    if ((openBetsList[i].bets[0].betType.name === TO_WIN.name || openBetsList[i].bets[0].betType.name === TO_WIN_EW.name) && openBetsList[i].bets[0].racers[0].num === racer.num) {
                        return openBetsList[i];
                    }
                }
            }
        }
        return undefined;

    }

    _getLastPositionsUI() {
        let listOfSingleBetsCardsUI = [];
        this.selectedRaceCardSortField = 'sortByNumber';
        if (this.state.events.length > 0 && this.state.events[this.state.selectedEventIndex].racers !== undefined) {
            let listOfSingleBetsCards = this.state.events[this.state.selectedEventIndex].racers.sort(sortRacers.bind(this));

            listOfSingleBetsCardsUI = listOfSingleBetsCards.map((racer, index) => {
                let eventType = this.state.events[this.state.selectedEventIndex].eventType;
                let lastWin = null;
                if (this.state.games[this.state.selectedGameIndex].lastResults !== undefined) {
                    let lastRaceResult = this.state.games[this.state.selectedGameIndex].lastResults.find((num) => num.number === racer.num);
                    if (lastRaceResult !== undefined && lastRaceResult !== null) {
                        lastWin = lastRaceResult.lastWin;
                    }
                }
                let store = this.props.store;
                let storeData = store.getState();

                let label;
                if (lastWin === 0) {
                    label = getText('WIN_INITIAL', this.props.store);
                } else if (lastWin === undefined || lastWin === null) {
                    label = getText('LOSE_INITIAL', this.props.store) + '1';
                } else {
                    label = getText('LOSE_INITIAL', this.props.store) + lastWin;
                }
                let racerIcon = style.motorRacerIcon;
                let position = style.motorRacerPosition;

                if (hasEventTypeRacerNumberUI(eventType)) {
                    racerIcon = style.racerIcon;
                    position = style.position
                }
                return (
                    <div key={index} id={'racer_' + racer.num} className={`${style.container}`}>
                        {/* <div id={'racer_number_' + this.props.racer.num} className={style.racerNumber}>{this.props.racer.num}</div> */}
                        <div id={'racer_silk_' + racer.num} className={`${racerIcon}`}>
                            <img
                                src={`${ASSETS_URL}${getGameFromChannel(this.state.events[this.state.selectedEventIndex].channel, storeData.vpp.games).assetsPath}/silks/silk${Number(racer.silk) +
                                1}.png`}
                                className={style.racerIconImage}
                                alt={`icon${racer.silk}`}/>
                            {
                                hasEventTypeRacerNumberUI(eventType)
                                    ? (<div id={'slider_racer_number_' + racer.num}
                                            className={style.silkNumber}>{racer.num}</div>)
                                    : ''
                            }
                        </div>
                        <div className={`${position}`}>
                            {label}
                        </div>

                    </div>
                );
            });

        }
        return listOfSingleBetsCardsUI;
    }


}

export default connect(mapStateToProps)(QuickBetCardRacing);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/quickBetCardRacing.js